import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  DialogTitle,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
} from '@mui/material';
import useAuthContext from '../auth/useAuthContext';
import useUser from '../data/useUser';

function ProjectSelectDialog({
  open, handleClose, projects, setCurrentProject, currentProject,
}) {
  const { user } = useAuthContext();
  // const { projects, currentProject, setCurrentProject } = useProjects({ user });
  // const [projects] = useState(initProjects);
  const [projectId, setProjectId] = useState(currentProject);

  console.log(projects);
  const { data, updateUser } = useUser({ user });

  const handleSubmit = (event) => {
    event.preventDefault();
    handleClose();
  };

  const handleProjectChange = (event) => {
    const { value } = event.target;
    const project = projects.find((p) => p.project === value);
    if (project) {
      setCurrentProject(project.project);
      setProjectId(project.project);
      updateUser({
        currentProject: project.project,
      });
      console.log(data);
    } else {
      console.error(`Could not find project with id ${value}`);
      setCurrentProject(null);
      setProjectId(null);
    }
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Select Project</DialogTitle>
      <Box
        component='form'
        onSubmit={handleSubmit}
        sx={{
          width: '100%',
          m: 1,
        }}
      >
        <Paper elevation={0}>
          {projects && projects.length > 0 ? (
            <RadioGroup value={projectId} onChange={handleProjectChange}>
              {projects
                && projects.map((project) => (
                  <FormControlLabel
                    value={project.project}
                    key={project.project + project.user}
                    control={<Radio />}
                    label={project.project}
                  />
                ))}
            </RadioGroup>
          ) : (
            <p>No projects to show.</p>
          )}
        </Paper>
      </Box>
    </Dialog>
  );
}

ProjectSelectDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  setCurrentProject: PropTypes.func,
  currentProject: PropTypes.string,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      project: PropTypes.string,
      user: PropTypes.string,
      description: PropTypes.string,
      languages: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          code: PropTypes.string,
        }),
      ),
    }),
  ),

};

ProjectSelectDialog.defaultProps = {
  open: false,
  handleClose: () => {},
  setCurrentProject: () => {},
  projects: [],
  currentProject: '',
};

export default ProjectSelectDialog;
